// extracted by mini-css-extract-plugin
export default {"person":"person_person__fE8Wu","image":"person_image__yz3q0","info":"person_info__E-J0-","bio":"person_bio__MXdCY"};